import React from 'react'
import { useState } from 'react'
import Timeline from './timeline'
import { timelineObject } from '../../../utils/timelineObject'
import '../../../commonCSS/cards.scss'
import CollapseHeader from '../collapseHeader'

function ChangelogSection({ changelog }: { changelog: ReadmeSection }) {
    const [collapsed, setCollapsed] = useState(false)
    const timeline = timelineObject(changelog)
    return (
        <div className="readmeSection">
            <CollapseHeader
                collapsed={collapsed}
                setCollapsed={setCollapsed}
                headerTag={changelog.header}
            />
            {!collapsed &&
                Object.keys(timeline).map((key, index) => (
                    <Timeline
                        version={key}
                        content={timeline[key]}
                        key={index}
                    />
                ))}
        </div>
    )
}

export default ChangelogSection
